import {CORE, gateway} from '../../api';

export const getCategorias = () => gateway.get(`${CORE}/categorias`);
